import React from "react"
import { Link } from "react-router-dom"
const profile = require("../assets/images/users/plumber.jpg");
import { canRequireUser } from "../login/loginHelpers";
import { AccountData } from "../generated";
import { links } from "../routes";
import LoginActions from "../login/LoginActions";
import { DropDownContainer } from "../common/components/dropDownMenu";

const SidebarUserProfile: React.FunctionComponent<{ user: AccountData | null }> = ({ user }) => {
    return (
        <DropDownContainer>
            {
                toggle => <div className="user-profile">
                    <div className="profile-img">
                        <img src={profile} alt="user" className="rounded-circle bg-white"
                        />
                    </div>
                    <div className="profile-text">
                        <Link
                            to={user == null ? links.login : "#"}
                            className="dropdowncontainer-toggle"
                            data-bs-toggle="dropdown"
                            role="button"
                            aria-haspopup="true"
                            aria-expanded="true"
                            onClick={toggle}
                        >
                            <div>{user != null ? user.nomeOperatore : "Accedi"}</div>
                            <div><i className="fas fa-chevron-down text-white" /></div>
                        </Link>
                        <div className="dropdown-menu animated flipInY">
                            {user == null && <Link to={links.login} className="dropdown-item">
                                Accedi
                            </Link>}
                            {user != null &&
                                <>
                                    <Link
                                        to={links.companyOperators}
                                        className="dropdown-item">
                                        <i className="ti-settings" /> La mia azienda
                                    </Link>
                                    <div className="dropdown-divider" />
                                    <Link to={links.login} onClick={() => LoginActions.signOut()} className="dropdown-item">
                                        <i className="fa fa-power-off" /> Esci
                                    </Link>
                                </>
                            }
                        </div>
                    </div>
                </div>
            }
        </DropDownContainer>

    )
}


export default canRequireUser(SidebarUserProfile);